import { getID } from "src/libs/utilities";
import { TIMELINE_DIAGRAM_TYPE } from "../interfaces";

export default function vertical_timeline(): any[] {
    return [
        {
            "dots": {
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 8,
                "color": "var(--actual-success-color)",
                "radius": 0,
                "stroke_width": 2,
                "dot_stroke_width": 0,
                "stroke": "var(--success)",
                "fontColor": "transparent",
                "fontSize": 0.1,
                "weight": 1, 
                "significant_zero": 0,
                "amplitude": 0, 
                "length": 0.6,
                "phase": 0, 
                "dot_style": { "border--": "2px solid var(--force-contast-color)", "color": "var(--actual-success-color)", transition: "300ms all ease" },
                active_dot_style: {
                    width: 18,
                    height: 18,
                    border:"3px solid var(--actual-success-color)",
                    "backgroundColor": "var(--main-bg-color)", 
                    "color": "var(--force-plain-color)",
                    transform: "translateX(-8px) translateY(-6px)"
                },
            },
            title: "Minimal",
        },
        {
            "dots": {
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 28,
                "color": "var(--danger)",
                "radius": 0,
                "dot_stroke_width": 20,
                "stroke": "var(--main-bg-color)",
                "fontColor": "transparent",
                "fontSize": 0.1,
                "weight": 1, 
                "significant_zero": 0,
                "amplitude": 40, 
                "length": 0.6,
                "phase": 0, 
                "dot_style": { "border--": "2px solid var(--force-contast-color)", "color": "var(--danger)", transform: "translateY(-10px)", transition: "300ms all ease"  },
                active_dot_style: { 
                    "backgroundColor": "darkred", 
                    width: 100,
                    transform: "translateX(-33px) translateY(-10px)"
                },
            },
            title: "Топос"
        },
        {
            "dots": {
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 60,
                "color": "var(--force-contast-color)",
                "fontColor": "var(--force-plain-color)",
                "fontSize": 33,
                "weight": 1,
                "radius": 60,
                "significant_zero": true,
                "amplitude": 0, 
                "length": 0.6,
                "phase": 0,
                "stroke_width": 2,
                "dot_style": { "border": "2px solid var(--force-contast-color)", fontWeight: 100 },
                active_dot_style: { 
                    "border": "2px solid var(--danger)",
                    "backgroundColor": "var(--danger)", 
                },
          },
                "title": "Огромные блябмы",
        },
        {
            "dots": {
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 25,
                "color": "var(--danger)",
                "fontColor": "var(--force-plain-color)",
                "fontSize": 0.1,
                "weight": 1,
                "radius": 0,
                "significant_zero": 0,
                "amplitude": 30, 
                "length": 0.4,
                "phase": 0,
                "stroke_width": 0.1,
                "svg_style": { "strokeDasharray": "4 2" },
                "dot_style": {  
                    "background": "var(--danger)!important",
                    transition: "300ms all ease", 
                    "clipPath": " polygon( -0.198% 32.313%,-0.198% 32.313%,-0.198% 31.788%,-0.198% 31.263%,-0.198% 30.74%,-0.198% 30.217%,-0.198% 29.695%,-0.198% 29.175%,-0.198% 28.657%,-0.198% 28.142%,-0.198% 27.629%,-0.198% 27.119%,-0.198% 27.119%,-0.182% 27.086%,-0.163% 27.053%,-0.143% 27.02%,-0.121% 26.987%,-0.099% 26.955%,-0.077% 26.922%,-0.055% 26.889%,-0.035% 26.856%,-0.016% 26.823%,-0% 26.791%,0% 26.791%,0.118% 25.813%,0.266% 24.847%,0.441% 23.893%,0.643% 22.948%,0.871% 22.013%,1.125% 21.086%,1.402% 20.167%,1.704% 19.253%,2.027% 18.345%,2.373% 17.441%,2.373% 17.441%,4.168% 13.777%,6.401% 10.511%,9.014% 7.673%,11.95% 5.289%,15.151% 3.39%,18.559% 2.002%,22.118% 1.154%,25.769% 0.874%,29.455% 1.191%,33.119% 2.132%,33.119% 2.132%,35.236% 2.971%,37.231% 3.973%,39.109% 5.132%,40.876% 6.442%,42.536% 7.894%,44.095% 9.482%,45.559% 11.199%,46.933% 13.039%,48.222% 14.995%,49.432% 17.059%,49.432% 17.059%,49.491% 17.159%,49.551% 17.262%,49.611% 17.369%,49.672% 17.478%,49.734% 17.592%,49.798% 17.708%,49.864% 17.828%,49.931% 17.951%,50.001% 18.077%,50.074% 18.207%,50.074% 18.207%,50.402% 17.575%,50.734% 16.958%,51.07% 16.355%,51.412% 15.765%,51.761% 15.186%,52.117% 14.617%,52.481% 14.056%,52.855% 13.502%,53.239% 12.954%,53.633% 12.411%,53.633% 12.411%,54.037% 11.875%,54.447% 11.348%,54.864% 10.832%,55.289% 10.325%,55.722% 9.828%,56.164% 9.341%,56.615% 8.863%,57.077% 8.396%,57.549% 7.938%,58.033% 7.49%,58.033% 7.49%,59.94% 5.914%,61.895% 4.534%,63.898% 3.357%,65.949% 2.39%,68.049% 1.64%,70.198% 1.113%,72.396% 0.816%,74.643% 0.755%,76.941% 0.936%,79.288% 1.367%,79.288% 1.367%,82.424% 2.289%,85.307% 3.511%,87.94% 5.027%,90.326% 6.832%,92.468% 8.919%,94.368% 11.283%,96.029% 13.919%,97.454% 16.821%,98.645% 19.983%,99.605% 23.401%,99.605% 23.401%,99.691% 23.78%,99.772% 24.161%,99.849% 24.544%,99.922% 24.929%,99.994% 25.314%,100.064% 25.7%,100.133% 26.084%,100.202% 26.468%,100.273% 26.849%,100.346% 27.228%,100.346% 27.228%,100.346% 27.753%,100.346% 28.277%,100.346% 28.801%,100.346% 29.324%,100.346% 29.846%,100.346% 30.365%,100.346% 30.883%,100.346% 31.399%,100.346% 31.912%,100.346% 32.422%,100.346% 32.422%,100.292% 32.443%,100.25% 32.473%,100.216% 32.51%,100.191% 32.552%,100.173% 32.6%,100.161% 32.65%,100.154% 32.703%,100.15% 32.756%,100.148% 32.809%,100.148% 32.859%,100.148% 32.859%,100.065% 33.547%,99.964% 34.23%,99.844% 34.908%,99.706% 35.582%,99.549% 36.249%,99.372% 36.91%,99.176% 37.564%,98.96% 38.21%,98.724% 38.847%,98.468% 39.475%,98.468% 39.475%,97.751% 41.072%,96.968% 42.617%,96.126% 44.115%,95.23% 45.57%,94.284% 46.986%,93.296% 48.368%,92.271% 49.719%,91.213% 51.045%,90.13% 52.349%,89.026% 53.636%,89.026% 53.636%,87.501% 55.359%,85.953% 57.054%,84.386% 58.726%,82.803% 60.381%,81.21% 62.022%,79.609% 63.654%,78.004% 65.284%,76.4% 66.915%,74.8% 68.553%,73.208% 70.202%,73.208% 70.202%,71.522% 71.994%,69.848% 73.795%,68.187% 75.609%,66.542% 77.438%,64.916% 79.285%,63.31% 81.154%,61.728% 83.047%,60.171% 84.967%,58.642% 86.917%,57.143% 88.901%,57.143% 88.901%,56.392% 89.921%,55.654% 90.949%,54.927% 91.984%,54.213% 93.028%,53.51% 94.081%,52.819% 95.144%,52.139% 96.218%,51.472% 97.303%,50.817% 98.399%,50.173% 99.508%,50.173% 99.508%,50.063% 99.438%,49.968% 99.359%,49.887% 99.273%,49.816% 99.181%,49.753% 99.084%,49.696% 98.984%,49.643% 98.883%,49.591% 98.78%,49.538% 98.678%,49.481% 98.578%,49.481% 98.578%,48.898% 97.614%,48.306% 96.656%,47.706% 95.705%,47.096% 94.76%,46.478% 93.822%,45.851% 92.89%,45.215% 91.965%,44.569% 91.046%,43.915% 90.134%,43.253% 89.229%,43.253% 89.229%,41.191% 86.551%,39.073% 83.926%,36.905% 81.348%,34.694% 78.809%,32.446% 76.305%,30.166% 73.829%,27.861% 71.375%,25.538% 68.936%,23.202% 66.506%,20.86% 64.079%,20.86% 64.079%,19.405% 62.588%,17.949% 61.099%,16.498% 59.605%,15.056% 58.101%,13.631% 56.581%,12.226% 55.04%,10.847% 53.472%,9.5% 51.872%,8.189% 50.233%,6.92% 48.551%,6.92% 48.551%,6.129% 47.463%,5.362% 46.362%,4.622% 45.244%,3.917% 44.107%,3.25% 42.947%,2.628% 41.761%,2.056% 40.545%,1.539% 39.296%,1.083% 38.011%,0.692% 36.687%,0.692% 36.687%,0.591% 36.259%,0.495% 35.828%,0.403% 35.394%,0.315% 34.958%,0.229% 34.52%,0.144% 34.081%,0.06% 33.64%,-0.025% 33.198%,-0.11% 32.756%,-0.198% 32.313% )"
                },
                active_dot_style: { 
                    width: 45,
                    height: 45,
                    transform: "translateX(-10px) translateY(-8px)",
                    "backgroundColor": "var(--danger)", 
                },
            },
                "title": "Сердечкии"
        },
        {
            "dots": {
                
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 20,
                "color": "var(--main-bg-color)",
                "fontColor": "var(--force-plain-color)",
                "fontSize": 0.1,
                "weight": 4,
                "radius": 20,
                "significant_zero": 0,
                "amplitude": 0, 
                "length": 0.4,
                "phase": 0,
                "stroke_width": 4,
                "svg_style": { "stroke": "#4298c3" },
                "dot_style": {  
                    "border": "4px solid #4298c3"
                }
          },
                "title": "Голубой вагон",
        },
        {
            "dots": {
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 7,
                "color": "var(--force-plain-color)",
                "fontColor": "var(--force-contast-color)",
                "fontSize": 20,
                "weight": 4,
                "radius": 0,
                "significant_zero": 0,
                "amplitude": 0, 
                "length": 0.25,
                "phase": 0,
                "stroke_width": 34,
                "dot_stroke_width": 26,
                "svg_style": { "stroke": "var(--drop-select-color)" },
                "dot_style": {  
                    "border": "4px solid var(--drop-select-color)",
                    "fontWeight": 900
                }
          },
          "title": "Компостер"
        },
        {
            "dots": {
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 70,
                "color": "var(--main-bg-color)",
                "fontColor": "var(--force-contast-color)",
                "fontSize": 25,
                "weight": 4,
                "radius": 70,
                "significant_zero": 0,
                "amplitude": 0, 
                "length": 0.25,
                "phase": 0,
                "stroke_width": 0.5,
                "dot_stroke_width": 1,
                "svg_style": { "stroke": "var(--drop-select-color)" },
                "dot_style": {  
                    "border": "0.5px solid var(--drop-select-color)",
                    "fontWeight": 100
                },
                active_dot_style: {
                    "backgroundColor": "var(--red)!important",
                    "color": "var(--force-plain-color)!important", 
                },
            },
            "title": "Светлые блямбы",
        },
        {
            "dots": {
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 15,
                "color": "var(--main-bg-color)",
                "fontColor": "var(--force-contast-color)",
                "fontSize": 0.025,
                "weight": 4,
                "radius": 20,
                "significant_zero": 0,
                "amplitude": 0,
                "length": 0.25,
                "phase": 0,
                "stroke_width": 4,
                "dot_stroke_width": 1,
                "svg_style": { "stroke": "var(--force-contrast-secondary-opacity-color)" },
                "dot_style": {
                    "border": "4px solid salmon",
                    "fontWeight": 100
                },
                active_dot_style: { 
                    "backgroundColor": "salmon", 
                },
            },
            "title": "Розовые точки",
        },
        {
             "dots": { 
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 0,
                "color": "var(--main-bg-color)",
                "fontColor": "var(--force-contast-color)",
                "fontSize": 0.25,
                "weight": 4,
                "radius": 0,
                "significant_zero": 0,
                "amplitude": 0, 
                "length": 0.7,
                "phase": 0,
                "stroke_width": 2,
                "dot_stroke_width": 1,
                "svg_style": { "stroke": "var(--drop-select-color)" },
                "dot_style": {  
                    "minWidth": 15,
                    "height": 0, 
                    "border": "none",
                    "borderTop": "1px solid var(--drop-select-color)",
                    "fontWeight": 100
                }
            },
            "title": "Риски",
        },
        {
            "dots": {
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 36,
                "color": "var(--force-plain-color)",
                "fontColor": "var(--force-contast-color)",
                "fontSize": 13,
                "weight": 1,
                "round": 22,
                "significant_zero": true,
                "amplitude": 0, 
                "length": 0.6,
                "phase": 0,
                "stroke_width": 2,
                "svg_style--": { "strokeDasharray": "4 2" },
                "dot_style": { "border": "2px solid var(--force-contast-color)" }
            },
            "title": "Лёгкие кубики",
        },
        {
            "dots": {
                id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 25,
                "color": "var(--red)",
                "fontColor": "#FFFFFF",
                "fontSize": 12,
                "weight": 1,
                "round": 45,
                "significant_zero": 0,
                "amplitude": 60, 
                "length": 0.6,
                "phase": 0,
                "stroke_width": 1,
                "svg_style": { "strokeDasharray": "2 4", "stroke": "var(--red)" },
                "dot_style": { 
                    "fontWeight": 100,
                    "clipPath": "polygon( 51.572% 95.626%,34.801% 75.992%,8.595% 78.332%,8.595% 78.332%,6.896% 78.288%,5.342% 77.885%,3.963% 77.172%,2.792% 76.198%,1.861% 75.013%,1.199% 73.666%,0.84% 72.207%,0.813% 70.685%,1.152% 69.149%,1.887% 67.65%,15.933% 46.083%,5.556% 22.686%,5.556% 22.686%,5.074% 21.097%,4.989% 19.534%,5.26% 18.04%,5.851% 16.66%,6.722% 15.437%,7.835% 14.416%,9.152% 13.64%,10.634% 13.154%,12.243% 13.001%,13.941% 13.225%,39.413% 19.532%,59.119% 2.645%,59.119% 2.645%,60.538% 1.708%,62.052% 1.14%,63.606% 0.922%,65.145% 1.032%,66.614% 1.45%,67.957% 2.154%,69.119% 3.125%,70.044% 4.341%,70.678% 5.782%,70.964% 7.426%,72.642% 32.859%,95.178% 45.88%,95.178% 45.88%,96.547% 46.887%,97.575% 48.098%,98.267% 49.458%,98.628% 50.908%,98.664% 52.391%,98.378% 53.849%,97.777% 55.226%,96.865% 56.463%,95.648% 57.504%,94.13% 58.291%,69.706% 67.752%,63.941% 92.675%,63.941% 92.675%,63.417% 94.263%,62.574% 95.6%,61.474% 96.671%,60.176% 97.464%,58.74% 97.965%,57.224% 98.162%,55.69% 98.039%,54.197% 97.585%,52.805% 96.785%,51.572% 95.626% )"
                },
                active_dot_style: {
                    backgroundColor: "var(--force-contast-color)!important"
                },
            },
            "title": "Рубиновый фейерверк",
        },
        {
            "dots": {
                 id: getID("timeline"),
                "type": TIMELINE_DIAGRAM_TYPE.SINUSOID,
                "perimeter": 45,
                "color": "transparent",
                "fontColor": "#FFFFFF",
                "fontSize": 0.12,
                "weight": 1,
                "round": 45,
                "significant_zero": 0,
                "amplitude": 60, 
                "length": 0.6,
                "phase": 0,
                "stroke_width": 1,
                "svg_style": { "strokeDasharray": "9 3", "stroke": "var(--force-contrast-opacity-color)" },
                "dot_style": { 
                "position": "relative",
                "fontWeight": 100,
                "borderRadius": 100
                },
                "dot_after_style": { 
                "content": "",
                "position": "absolute",
                "fontWeight": 100,
                "borderRadius": "45px",
                "width": "45px",
                "height": "45px",
                "backgroundColor": "#FFFFFF",
                "boxShadow": "0 3px 9px 1px rgba(00,00,00,.13), 0 2px 3px 1px rgba(00,00,00,.21)"
                },
                "dot_before_style": {
                "content": "",
                "zIndex": 3,
                "position": "absolute",
                "top": "10px",
                "left": "10px",
                "width": "25px",
                "height": "25px",
                "backgroundColor": "#000000",
                "clipPath": "polygon( 49.371% 5.086%,49.371% 5.086%,43.735% 5.527%,38.386% 6.802%,33.395% 8.844%,28.834% 11.584%,24.777% 14.954%,21.296% 18.886%,18.462% 23.311%,16.348% 28.16%,15.027% 33.366%,14.57% 38.861%,14.57% 38.861%,15.372% 44.985%,17.576% 51.955%,20.879% 59.42%,24.979% 67.027%,29.573% 74.428%,34.359% 81.27%,39.034% 87.202%,43.296% 91.874%,46.843% 94.934%,49.371% 96.033%,49.371% 96.033%,52.205% 94.937%,55.929% 91.884%,60.263% 87.221%,64.927% 81.299%,69.641% 74.466%,74.126% 67.071%,78.101% 59.464%,81.287% 51.994%,83.404% 45.01%,84.172% 38.861%,84.172% 38.861%,83.715% 33.366%,82.394% 28.16%,80.28% 23.311%,77.447% 18.886%,73.965% 14.954%,69.908% 11.584%,65.347% 8.844%,60.356% 6.802%,55.007% 5.527%,49.371% 5.086%,49.371% 57.884%,49.371% 57.884%,46.202% 57.637%,43.197% 56.922%,40.398% 55.777%,37.844% 54.241%,35.574% 52.352%,33.628% 50.149%,32.045% 47.67%,30.865% 44.954%,30.129% 42.038%,29.874% 38.962%,29.874% 38.962%,30.129% 35.886%,30.865% 32.971%,32.045% 30.254%,33.628% 27.775%,35.574% 25.572%,37.844% 23.683%,40.398% 22.147%,43.197% 21.003%,46.202% 20.288%,49.371% 20.041%,49.371% 20.041%,52.541% 20.288%,55.545% 21.003%,58.344% 22.147%,60.898% 23.683%,63.168% 25.572%,65.114% 27.775%,66.697% 30.254%,67.877% 32.971%,68.614% 35.886%,68.868% 38.962%,68.868% 38.962%,68.614% 42.038%,67.877% 44.954%,66.697% 47.67%,65.114% 50.149%,63.168% 52.352%,60.898% 54.241%,58.344% 55.777%,55.545% 56.922%,52.541% 57.637%,49.371% 57.884% )"
                
                }
            },
            title:"Маршрут"
        }
    ]
}